<template>
  <div :class="$style.Swipe">
    <swipe :class="$style.swipeContainer" :speed="800" :auto="5000">
      <swipe-item :class="$style.swipeItem" v-for="(item,index) in list" :key="item.title">
        <div :class="$style.swipeItem1">
          <img :src="item.logo" :class="$style.logo">
          <div :class="$style.content">
            <div :class="$style.title">{{item.title}}</div>
            <div :class="$style.subTitle"><span>{{item.subTitle}}</span></div>
            <div :class="$style.lbsTxt" v-if="item.lbs">{{item.lbs}}km</div>
          </div>
          <button :class="$style.btnYellow+' btn-yellow'" @click="changePage(index+1,item.url)">{{item.btnTxt}}</button>
        </div>
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vue-swipe'
import logo from '../assets/imgs/new-logo.png'
import avatar1 from '../assets/imgs/avatar-1.png'
import avatar2 from '../assets/imgs/avatar-2.png'
import avatar3 from '../assets/imgs/avatar-3.png'
import avatar4 from '../assets/imgs/avatar-4.png'
import avatar5 from '../assets/imgs/avatar-5.png'
import { randomKM } from "../util";
require('vue-swipe/dist/vue-swipe.css')
export default {
  data () {
    return {
      list: [
        {
          title: '4Fun',
          subTitle: 'Funny Videos, Status, Live Voice Chat',
          btnTxt: 'Install',
          sex: '',
          logo: logo,
          lbs:'',
          url:'https://play.google.com/store/apps/details?id=com.nebula.mamu.lite&referrer=utm_source%3Dusr_fun_beautiful4',
        },
        {
          title: 'Himani🌹🌹',
          subTitle: '',
          btnTxt: 'Live Chat With He',
          sex: 'Her',
          logo: avatar1,
          lbs:randomKM(),
          url:'https://play.google.com/store/apps/details?id=com.nebula.mamu.lite&referrer=utm_source%3Dusr_C40983B2660D7EA8_sp-WkNYVVFIWFw=',
        },
        {
          title: 'Abhishek the Rock st',
          subTitle: '',
          btnTxt: 'Live Chat With She',
          sex: 'Him',
          logo: avatar2,
          lbs:randomKM(),
          url:'https://play.google.com/store/apps/details?id=com.nebula.mamu.lite&referrer=utm_source%3Dusr_C40983B2660D7EA8_sp-WkNZVV9AWFc=',
        },
        {
          title: 'Piyasaini90',
          subTitle: '',
          btnTxt: 'Live Chat With He',
          sex: 'Her',
          logo: avatar3,
          lbs:randomKM(),
          url:'https://play.google.com/store/apps/details?id=com.nebula.mamu.lite&referrer=utm_source%3Dusr_C40983B2660D7EA8_sp-WkNYVFtBUVs=',
        },
        {
          title: '👉हम हम है👈👆',
          subTitle: '',
          btnTxt: 'Live Chat With She',
          sex: 'Her',
          logo: avatar4,
          lbs:randomKM(),
          url:'https://play.google.com/store/apps/details?id=com.nebula.mamu.lite&referrer=utm_source%3Dusr_C40983B2660D7EA8_sp-WkNYU11IXFc=',
        },
        {
          title: 'Prince Roy',
          subTitle: '',
          btnTxt: 'Live Chat With Her',
          sex: 'Him',
          logo: avatar5,
          lbs:randomKM(),
          url:'https://play.google.com/store/apps/details?id=com.nebula.mamu.lite&referrer=utm_source%3Dusr_C40983B2660D7EA8_sp-WkNZVV9AWFc=',
        }
      ]
    }
  },
  components: {
    'swipe': Swipe,
    'swipe-item': SwipeItem
  },
  mounted () {
  },
  methods: {
    changePage(index,url){
      window._czc.push(['_trackEvent', 'swipe', index]);
      setTimeout(() => {
          this.$store.dispatch('setPage',2)
      }, 50);
      setTimeout(() => {
        location.href=url
      }, 300);
    }
  }
}
</script>

<style module lang="scss">
.Swipe {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #EAECF0;
  .swipeItem {
    width: 100%;
    height: 56px;
  }
  .swipeItem1 {
    @extend .swipeItem;
    display: flex;
    align-items: center;
  }
  .logo {
    width: 32px;
    height: 32px;
    margin-left: 16px;
  }
  .content {
      text-align:left;
      margin-left: 6px;
  }
  .title {
      font-size: 16px;
      font-family: Roboto-Black, Roboto;
      font-weight: 900;
      color: #303133;
    }
    .subTitle{
        font-family:Roboto-Regular,Roboto;
        font-weight:400;
        color:rgba(155,156,161,1);
        text-align: left;
        span{
            font-size:12px;
            transform: scale(0.82);
        }
    }
    .btnYellow{
        position:absolute;
        top:50%;
        right:16px;
        transform: translateY(-50%);
        font-size: 14px;
    }
    .lbsTxt{
      background: url('../assets/imgs/ico-lbs-gray.svg') left center no-repeat;
      background-size:contain;
      width: 10px;
      height:10px;
      padding-left:14px;
      font-size:12px;
      font-family:Roboto-Regular,Roboto;
     font-weight:400;
     color:rgba(155,156,161,1);
     margin-top: 2px;
    }
}
</style>
<style lang="scss" >
.mint-swipe-indicator{
  background: #D8D8D8;
  opacity: 1;
}
.mint-swipe-indicators{
    bottom: 4px;
}
.mint-swipe-indicator {
  width: 4px;
  height: 4px;
}
.mint-swipe-indicator.is-active {
  background: #FF9100;
}
</style>
